// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaceOrder_root__vBU0H"};